import { ref } from 'vue';
const clickTimeout = 500;
let canClick = true;

export const useClinicControls = (
  scrollContainer: HTMLElement,
  controlElement: HTMLElement | null,
) => {
  const index = ref(0);
  const maxIndex = 17;
  const { isVs } = useViewportSize();
  const calculatePositions = () => {
    const height = scrollContainer?.parentElement?.clientHeight || 1;

    const unit = (height / 19) * 3;

    const array: number[] = [];
    const topOffset = document.documentElement.getBoundingClientRect().top;
    let previousStep =
      (scrollContainer?.parentElement?.getBoundingClientRect().top as number) -
      topOffset;

    const distances = [
      0.2, 0.3, 0.5, 0.2, 0.3, 0.5, 0.2, 0.3, 0.5, 0.2, 0.8, 0.17, 0.3, 0.53,
      0.2, 0.15, 0.65,
    ];

    for (let i = 0; i < maxIndex; i++) {
      const distance = isVs.value ? unit / 3 : distances[i] * unit;

      array.push(previousStep + distance);
      previousStep += distance;
    }

    return array;
  };

  const positions: number[] = calculatePositions() as number[];

  const forward = () => {
    if (!canClick) return;
    canClick = false;
    setTimeout(() => (canClick = true), clickTimeout);

    if (typeof window !== 'undefined') {
      window?.scroll({
        left: 0,
        top: positions[index.value],
        behavior: 'smooth',
      });
    }

    updateControlElement(index.value);

    index.value++;
  };

  const setIndex = (value: number) => {
    index.value = value;
  };

  const updateControlElement = (index: number) => {
    if (index <= maxIndex - 3) {
      controlElement?.classList.remove('last-step');
    }
    if (index === maxIndex - 2) {
      controlElement?.classList.remove('finished');
      controlElement?.classList.add('last-step');
    }
    if (index === maxIndex - 1) {
      controlElement?.classList.remove('last-step');
      controlElement?.classList.add('finished');
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      const indexValue = positions.findIndex(
        (position) => position >= scrollPosition + 20,
      );
      if (indexValue !== -1) {
        updateControlElement(indexValue - 1);

        index.value = indexValue;
      }
    });
  }

  return {
    index,
    forward,
    setIndex,
  };
};
